import { render, staticRenderFns } from "./yearbook_card.vue?vue&type=template&id=5633f768"
import script from "./yearbook_card.vue?vue&type=script&lang=js"
export * from "./yearbook_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports